import { render, staticRenderFns } from "./DataFileImport.vue?vue&type=template&id=10951f90&scoped=true&"
import script from "./DataFileImport.vue?vue&type=script&lang=js&"
export * from "./DataFileImport.vue?vue&type=script&lang=js&"
import style0 from "./DataFileImport.vue?vue&type=style&index=0&id=10951f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10951f90",
  null
  
)

export default component.exports